import { styled } from 'goober';
import { ThemeColorKeys } from '../../base/useTheme';

export const Question = styled('p')`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    margin-bottom: 18px;
    color: ${(props) => props.theme.colors.ui.dark};
`;

export const Message = styled('p')<{ $color: ThemeColorKeys }>`
    padding: 10px;
    margin-bottom: 18px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 12px;
    line-height: 150%;
    color: ${(props) => props.theme.colors[props.$color].w500};
    background-color: ${(props) => props.theme.colors[props.$color].w50};
`;
